import React, { useCallback } from "react";

import { labels } from "./labels";

import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import { useAppContext } from "../../hooks/useAppContext";
import { useLabels } from "../../hooks/useLabels";
import { useNavigateToUrl } from "../../hooks/useNavigate";
import { showSaveAndConfirmDialogAsync } from "../dialogs/save-dialog";
import { Logo } from "./logo";

import "./logo.css";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { showLeaveDialogAsync } from "../dialogs/leave-dialog/leave-dialog";

export const LogoContainer = ({ showLargeLogo }: { showLargeLogo: boolean }) => {
	const [[logoHtml]] = useLabels([showLargeLogo ? labels.logo : labels.shortLogo]);

	const { busyBlocker } = useBusyBlockerContext();
	const {
		editor,
		context: { account, homeUrl },
		googleAnalytics,
	} = useAppContext();

	const { createErrorHandler } = useErrorHandling();

	const navigateToUrl = useNavigateToUrl();

	const handleLogoOnClick = useCallback(() => {
		// Log when company logo is clicked
		googleAnalytics.trackEventToGa({ trackingAction: "LogoClicked" });

		if (!editor.isDirty()) {
			navigateToUrl(homeUrl);
			return;
		}

		showLeaveDialogAsync()
			.then((shouldLeave) =>
				shouldLeave
					? showSaveAndConfirmDialogAsync({
							isLeavingPage: true,
							editor,
							busyBlocker,
							getIsSignedIn: () =>
								!!(account?.type === eXpress.core.AccountType.Full),
					  }).then((result) => result !== undefined)
					: false,
			)
			.then((shouldLeave) => {
				if (shouldLeave) {
					navigateToUrl("/");
				}
			})
			.catch(createErrorHandler());
	}, [account, busyBlocker, editor, homeUrl, googleAnalytics, navigateToUrl, createErrorHandler]);

	return !logoHtml ? null : <Logo html={logoHtml} onClick={handleLogoOnClick} />;
};
LogoContainer.displayName = "LogoContainer";
